import React, { useRef } from 'react'
import { Button } from '../../common'
import Logo from '../../../assets/Image-not-found.webp'
import { Suspense, useEffect, useState } from 'react'
import { ModalFormContact } from '../../Modais/ModalFormContact'
import IconMinus from '../../../assets/icons/minus-blue.svg'
import SkeletonLoading from '../../common/SkeletonLoading'
import { useAuth } from '../../../hooks/useAuth'
import { formatMoneyReal, isMobile } from '../../../common_functions'
import enterpriseApi from '../../../store/reducers/enterprise/enterpriseApi'
import clsx from 'clsx'
import { v4 } from 'uuid'
import TagPromotion from '../../../assets/tag_promo.webp'
import generalApi from '../../../store/reducers/general/generalApi'
import { CardFormContactLead } from '../../Cards/CardFormContactLead'

const ClampText: React.FC<{ text: string }> = ({ text }) => {
  const [isClamped, setIsClamped] = useState(false)
  const [seeMore, setSeeMore] = useState(false)
  const textRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (textRef.current) {
      setIsClamped(textRef.current.scrollHeight > textRef.current.clientHeight)
    }
  }, [text])

  const handleSeeMore = () => {
    setIsClamped(!isClamped)
    setSeeMore(!seeMore)
  }

  return (
    <div>
      <div
        className={clsx('text-base font-medium text-black leading-4 mt-3', {
          'line-clamp-3 overflow-hidden': !seeMore
        })}
        ref={textRef}
      >
        {text}
      </div>
      {isClamped ? (
        <button className="font-semibold underline mt-3" onClick={handleSeeMore}>
          Saiba Mais
        </button>
      ) : (
        <button className="font-semibold underline mt-3" onClick={handleSeeMore}>
          Ver menos
        </button>
      )}
    </div>
  )
}

interface EnterpriseDetailCard {
  CompanyName?: string | undefined
  DescriptionCompany?: string | undefined
  Price?: number
  LogoUrl?: string | undefined
  EnterpriseId: string
  LastPublish?: string
  ConstructionId?: string
  CampaignId?: string | null
  IsPromotion?: boolean | null
}

export default function CardEnterpriseInternInfosPriceTest({
  CompanyName = '',
  DescriptionCompany = '',
  Price = 0,
  EnterpriseId,
  LogoUrl,
  CampaignId,
  ConstructionId,
  IsPromotion = null
}: EnterpriseDetailCard) {
  const [showModal, setShowModal] = useState(false)
  const auth = useAuth()
  const guid = v4()
  const [isPromotion, setIsPromotion] = useState<null | boolean>(IsPromotion)

  const {
    data: dataInfo,
    isError: isErrorInfo,
    isLoading: isLoadingInfo,
    isSuccess: isSuccessInfo,
    status: statusInfo,
    error: errorInfo
  } = enterpriseApi.useGetEnterpriseInformationByIdQuery(EnterpriseId ?? '')

  const [
    useGetAllPromotions,
    { data: dataFair, isError: isErrorFair, isLoading: isLoadingFair, isSuccess: isSuccessFair }
  ] = generalApi.useGetPromotionsAllMutation()

  const getAllPromotions = async () => {
    await useGetAllPromotions(undefined)
  }

  const handleClickTenhoInteresse = () => {
    setShowModal(true)
  }

  useEffect(() => {
    if (isPromotion == null) {
      getAllPromotions()
    }
  }, [])

  useEffect(() => {
    if (isSuccessFair && dataFair) {
      setIsPromotion(dataFair?.Data.filter((x) => x.EnterpriseId == EnterpriseId).length > 0)
    }
  }, [isSuccessFair])

  useEffect(() => {
    let adPolicy = document.querySelector('#adopt-controller-button') as HTMLElement
    if (adPolicy != undefined) {
      adPolicy.style.setProperty('display', 'none', 'important')
    }

    let df = document.querySelector('df-messenger') as HTMLElement
    if (df != undefined) {
      df.style.display = 'none'
    }
  }, [location.href])

  return (
    <>
      <>
        <div className="card-enterprise-intern-infos-prices lg:hidden fixed bottom-0 shadow-lg w-full left-0 z-[10]">
          {isLoadingInfo && <SkeletonLoading height={150} />}
          {isSuccessInfo && (
            <div
              className="grid grid-cols-2 mx-5 shadow-lg py-5 px-3 bg-white m-auto"
              style={{ boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.2)' }}
            >
              {/* {isPromotion && <img src={TagPromotion} width={40} className='absolute right-10 top-0 -mt-[3px]'/>} */}
              <div className="m-auto ms-0">
                <h6 className="text-base font-semibold text-[#333]">
                  {Price === 0 ? 'Valor' : `A partir de`}
                </h6>
                <h6 className="text-[#4D4D4D] text-lg font-semibold">
                  {Price === 0 ? 'Sob Consulta' : `${formatMoneyReal(Price)}`}
                </h6>
              </div>
              <div className="m-auto me-0">
                <Button
                  variant="primary-gradient"
                  onClick={handleClickTenhoInteresse}
                  className="font-bold w-full text-white btn-submit-modal-form-contact"
                  paddingXClass="px-2"
                >
                  <small>TENHO INTERESSE</small>
                </Button>
              </div>
            </div>
          )}
        </div>
        <div className="hidden lg:inline">
          {isLoadingInfo && <SkeletonLoading height={300} />}
          {isSuccessInfo && (
            <div
              className="sticky rounded-2xl p-5 top-[0px] shadow-[0_0_15px_-0px_rgba(0,0,0,0.15)]"
              style={{ overflowWrap: 'anywhere' }}
            >
              <div className='h-100 w-100'>
                <small className="text-gray-700 font-semibold text-lg">A partir de</small>
                <h3 className="font-bold text-[#414141] text-3xl">
                  {Price === 0 ? 'Sob Consulta' : `${formatMoneyReal(Price)}`}
                </h3>
                <div className="mb-5">
                  <CardFormContactLead
                    campaignId={CampaignId}
                    btnBg="primary-gradient"
                    isPromotion={isPromotion ?? false}
                    formId={v4()}
                    constructionId={ConstructionId ?? ''}
                    enterpriseId={EnterpriseId}
                  />
                </div>
                {/* <div className="my-4">
                <Button
                  variant="orange"
                  onClick={handleClickTenhoInteresse}
                  className="font-bold w-full btn-submit-modal-form-contact"
                >
                  TENHO INTERESSE
                </Button>
              </div> */}
                <div>
                  <div className="grid grid-cols-5 grid-flow-col gap-3">
                    <div
                      className="col-span-1 m-auto flex mt-0 rounded-full border-1 border-gray-200 aspect-square"
                      style={{ alignItems: 'center' }}
                    >
                      <img
                        alt="Logo do anunciante"
                        src={LogoUrl != null && LogoUrl != '' ? LogoUrl : Logo}
                        className="w-full h-fit text-center rounded-full"
                      />
                    </div>
                    <div className="col-span-4 m-auto ml-0">
                      <small className="text-base text-gray-800">Empresa</small>
                      <a
                        href={`/construtora/${ConstructionId}`}
                        className="text-base text-gray-700 font-bold underline block"
                      >
                        {CompanyName}
                      </a>
                      <ClampText text={DescriptionCompany} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <ModalFormContact
          constructionId={ConstructionId ?? ''}
          showModal={showModal}
          closeModal={() => setShowModal(false)}
          enterpriseId={EnterpriseId}
        />
      </>
    </>
  )
}
